import React from 'react';
import { clsx } from 'clsx';

import { InputContainer, Props as BaseProps } from '../input-container';

type HtmlSelectProps = Omit<JSX.IntrinsicElements['select'], 'ref'>;
type HtmlOptionProps = Omit<JSX.IntrinsicElements['option'], 'ref'>;
type Props = HtmlSelectProps &
  BaseProps & {
    options: HtmlOptionProps[];
    register: (any: any) => any;
  };

const Select: React.FC<Props> = ({ id, label, options, register, error, ...props }) => (
  <InputContainer id={id} label={label} error={error}>
    <select
      {...props}
      id={id}
      name={props.name || id}
      className={clsx('form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5', {
        'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:ring-red': error,
      })}
      ref={register}
    >
      {options.map(({ label, ...optionProps }, index) => (
        <option key={`${id}-options-${index}`} {...optionProps}>
          {label}
        </option>
      ))}
    </select>
  </InputContainer>
);

export default Select;
